import React from 'react';

const HelloWorld = () => (
  <div>
    Hello World
  </div>
);

export default HelloWorld;